import { render, staticRenderFns } from "./fbaOverseaWarehousingDetail.vue?vue&type=template&id=0957665a&"
import script from "./fbaOverseaWarehousingDetail.vue?vue&type=script&lang=js&"
export * from "./fbaOverseaWarehousingDetail.vue?vue&type=script&lang=js&"
import style0 from "./fbaOverseaWarehousingDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0957665a')) {
      api.createRecord('0957665a', component.options)
    } else {
      api.reload('0957665a', component.options)
    }
    module.hot.accept("./fbaOverseaWarehousingDetail.vue?vue&type=template&id=0957665a&", function () {
      api.rerender('0957665a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/OverseaWarehousing/fbaOverseaWarehousingDetail.vue"
export default component.exports